module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["div_out"],
    style: {
      marginLeft: _vm.divLeft,
      width: _vm.imgWidth
    }
  }, [_c('slider', {
    staticClass: ["slider"],
    style: _vm.sliderStyle,
    attrs: {
      "interval": _vm.interval,
      "autoPlay": _vm.autoplay,
      "infinite": _vm.infinite
    },
    on: {
      "change": _vm.change
    }
  }, [_vm._l((_vm.slItems), function(item, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          _vm.imgClicked(item, index)
        }
      }
    }, [_c('image', {
      staticClass: ["image"],
      style: {
        width: _vm.imgWidth,
        height: _vm.imgHeight,
        backgroundColor: _vm.imageBgColor
      },
      attrs: {
        "resize": _vm.imgResize,
        "src": item.url,
        "placeholder": _vm.phImgUrl
      }
    })])
  }), (_vm.showIndicator && !_vm._isColmo) ? _c('indicator', {
    staticClass: ["indicator"],
    style: _vm.indicatorStyle
  }) : _vm._e()], 2), (_vm.showIndicator && _vm._isColmo) ? _c('div', {
    staticClass: ["indicator-box"]
  }, _vm._l((_vm.slItems), function(item, i) {
    return _c('div', {
      key: i,
      class: ['indicator-item', i === _vm.slItems.length - 1 && 'isLast', i == _vm.active && 'active'],
      style: _vm.indicatorStyle
    })
  })) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-556248de!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-swiper/index.vue
// module id = 615
// module chunks = 0 1